'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useParams } from 'next/navigation';
import fr from 'react-phone-number-input/locale/fr.json';
import nl from 'react-phone-number-input/locale/nl.json';
import en from 'react-phone-number-input/locale/en.json';
import pl from 'react-phone-number-input/locale/pl.json';

export default function usePhoneInputLabelLanguage() {
  let currentLanguage = null;
  const { locale } = useParams();

  switch (locale) {
    case 'nl':
      currentLanguage = nl;
      break;
    case 'fr':
      currentLanguage = fr;
      break;
    case 'pl':
      currentLanguage = pl;
      break;
    case 'ro':
    case 'en':
    default:
      currentLanguage = en;
      break;
  }

  return currentLanguage;
}
